import React, { useState, useEffect } from 'react';
import { Shield, Power } from 'lucide-react';
import { cn } from './lib/utils';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './lib/firebase';

export default function AdminPanel() {
  const [aiEnabled, setAiEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const configDoc = await getDoc(doc(db, 'config', 'admin'));
        if (configDoc.exists()) {
          setAiEnabled(configDoc.data().aiEnabled ?? false);
        }
      } catch (err) {
        console.error('Error loading admin config:', err);
      } finally {
        setLoading(false);
      }
    };
    loadConfig();
  }, []);

  const toggleAi = async () => {
    const newVal = !aiEnabled;
    setAiEnabled(newVal);
    try {
      await setDoc(doc(db, 'config', 'admin'), { aiEnabled: newVal }, { merge: true });
    } catch (err) {
      console.error('Error saving admin config:', err);
      setAiEnabled(!newVal); // revert on error
    }
  };

  if (loading) return <div className="p-8 text-white">Loading...</div>;

  return (
    <div className="min-h-screen bg-slate-950 p-8 flex justify-center items-start pt-24 font-sans">
      <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-3xl p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-8 pb-6 border-b border-slate-800">
          <Shield className="w-8 h-8 text-indigo-500" />
          <h1 className="text-2xl font-bold text-white">Admin Control</h1>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-white">AI Generation</h2>
            <p className="text-sm text-slate-400 mt-1">Allow users to generate banners using AI</p>
          </div>
          
          <button
            onClick={toggleAi}
            className={cn(
              "w-14 h-8 rounded-full relative transition-colors duration-300 focus:outline-none",
              aiEnabled ? "bg-indigo-600" : "bg-slate-700"
            )}
          >
            <div className={cn(
              "w-6 h-6 bg-white rounded-full absolute top-1 transition-transform duration-300 flex items-center justify-center",
              aiEnabled ? "left-7" : "left-1"
            )}>
              <Power className={cn("w-3.5 h-3.5", aiEnabled ? "text-indigo-600" : "text-slate-400")} />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
